import { render, staticRenderFns } from "./FooterCanadian.vue?vue&type=template&id=63f309e7&"
import script from "./FooterCanadian.vue?vue&type=script&lang=js&"
export * from "./FooterCanadian.vue?vue&type=script&lang=js&"
import style0 from "./FooterCanadian.vue?vue&type=style&index=0&id=63f309e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports